import React from "react";
import { useParams } from "react-router-dom";
import PartyForm from "./PartyForm";

export default function BuyerDetails() {
  const { buyerId } = useParams();
  return <PartyForm key={buyerId} type="buyer" recordId={buyerId} />;
}
